import { Box } from "@mui/material";
import {
  XAxis,
  YAxis,
  CartesianGrid,
  Tooltip,
  Legend,
  ResponsiveContainer,
  BarChart,
  Bar
} from 'recharts';

const ReportChart = ({ stackedChartData, stackKeys, appliedFilters, filters }) => {

  // Generate colors for chart lines/bars - avoiding blue, orange, purple
  const getColors = () => {
    const colors = [
      '#1b1c1b', // Neutral Primary (black)
      '#6e4c01', // Brown
      '#367c2b', // Theme Green
      '#78ab68', // Green 65
      '#ad7a03', // Yellow 55
      '#dda002', // Yellow 75
      '#ffde00', // Theme Yellow
      '#f2e1bd', // Sand
      '#e7e3d4', // Tan
      '#5d4037', // Dark Brown (instead of blue)
      '#8d6e63', // Medium Brown (instead of orange) 
      '#6d4c41', // Coffee Brown (instead of purple)
      '#4caf50', // Light Green
      '#2e7d32', // Dark Green (instead of red)
      '#795548', // Brown
      '#8bc34a', // Light Yellow Green (instead of blue grey)
      '#689f38', // Olive Green (instead of pink)
      '#558b2f', // Dark Olive (instead of teal)
      '#33691e'  // Very Dark Green (instead of indigo)
    ];
    return colors;
  };

  const getStackColors = () => {
    // Generate distinct colors for each reason code
    const baseColors = getColors();
    const stackColors = {};
    
    stackKeys.forEach((reasonCode, index) => {
      stackColors[reasonCode] = baseColors[index % baseColors.length];
    });
    
    return stackColors;
  };

  return (
    <Box sx={{ width: '100%', p: 2 }}>
      {/* Chart Container */}
      <Box sx={{ height: 400 }}>
        <ResponsiveContainer width="100%" height="100%">
          <BarChart
            data={stackedChartData}
            margin={{
              top: 20,
              right: 30,
              left: 20,
              bottom: 5,
            }}
          >
            <CartesianGrid strokeDasharray="3 3" />
            <XAxis dataKey="month" />
            <YAxis 
              allowDecimals={false}
              tickFormatter={(value) => {
                if ((appliedFilters && appliedFilters.volume === 'value') || (!appliedFilters && filters.volume === 'value')) {
                  return new Intl.NumberFormat('en-US', {
                    notation: 'compact',
                    maximumFractionDigits: 1
                  }).format(value);
                }
                return value;
              }}
            />
            <Tooltip 
              formatter={(value, name) => {
                // Display the reason code as the name
                const displayName = name;
                
                if ((appliedFilters && appliedFilters.volume === 'value') || (!appliedFilters && filters.volume === 'value')) {
                  return [
                    new Intl.NumberFormat('en-US', {
                      minimumFractionDigits: 2,
                      maximumFractionDigits: 2
                    }).format(value),
                    displayName
                  ];
                }
                return [value, displayName];
              }}
              labelFormatter={(label) => `Month: ${label}`}
            />
            <Legend 
              formatter={(value) => {
                // Show the reason code as legend label
                return value;
              }}
            />
            {stackKeys.map((stackKey, index) => (
              <Bar
                key={stackKey}
                dataKey={stackKey}
                stackId="a"
                fill={getStackColors()[stackKey]}
              />
            ))}
          </BarChart>
        </ResponsiveContainer>
      </Box>


    </Box>
  );
};

export default ReportChart;